import {Component, OnInit} from '@angular/core';
import {LayoutService} from '../../../../../core';
import {Observable} from 'rxjs';
import {UserModel} from '../../../../../../modules/auth';
import {AuthService} from '../../../../../../modules/auth';
import {UsersService} from '../../../../../../modules/auth/_services/users.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Overlay} from '@angular/cdk/overlay';

@Component({
    selector: 'app-user-offcanvas',
    templateUrl: './user-offcanvas.component.html',
    styleUrls: ['./user-offcanvas.component.scss'],
    providers: [MatSnackBar, Overlay]
})
export class UserOffcanvasComponent implements OnInit {
    extrasUserOffcanvasDirection = 'offcanvas-right';
    user$: Observable<UserModel>;

    offset;

    user;
    userLoaded: boolean;

    userRole;
    isClient;


    constructor(private layout: LayoutService, private auth: AuthService, private userService: UsersService) {
    }

    ngOnInit(): void {


        this.extrasUserOffcanvasDirection = `offcanvas-${this.layout.getProp(
            'extras.user.offcanvas.direction'
        )}`;
        this.user$ = this.auth.currentUserSubject.asObservable();

        this.userService.getCurrentUser().subscribe(res => {
            this.user = res;
            this.userLoaded = true;
        });

        this.userService.getCurrentUser().subscribe((res: any) => {
            this.userRole = res.roles;

            if (this.userRole !== null) {
                if (this.userRole.includes('ROLE_client')) {
                    this.isClient = true;
                } else {
                    this.isClient = false;
                }
            } else {
                this.isClient = false;
            }

        });
    }


    logout() {
        this.auth.logout();
        document.location.reload();
    }
}
